module.exports = __webpack_public_path__ + "static/media/surface-4.7401c3e0.png";